module.exports = __webpack_public_path__ + "img/DIS.a1eb2e86.png";